/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(() => {
    let searchanizeInstantInput = document.querySelector('[aria-controls="snize-instant-search-results"]');
    if (searchanizeInstantInput) {
      searchanizeInstantInput.setAttribute('aria-label', 'Instant search input');
    }

    let searchanizeCloseButton = document.querySelector('#snize-modal-sticky-searchbox .snize-close-button');
    if (searchanizeCloseButton) {
      searchanizeCloseButton.setAttribute('aria-label', 'Instant search close button');
    }

    let searchanizeSubmitButton = document.querySelector('#snize-modal-sticky-searchbox .snize-sticky-submit');
    if (searchanizeSubmitButton) {
      searchanizeSubmitButton.setAttribute('aria-label', 'Instant search submit button');
    }
    
  }, 5000);
});
